import configHandler from '../configHandler'

const ZIP_LENGTH = 'length'
const INVALID_VALUE = 'invalidValue'

export const getLength = () => {
    return configHandler.getZipFormat(ZIP_LENGTH)
}

const formatSV = (zipCode) => {
    return zipCode.substring(0, 3) + ' ' + zipCode.substring(3)
}

const formatNO = (zipCode) => {
    return zipCode
}

export const parse = (inputZipCode) => {
    let zipCode = String(inputZipCode)
        .replace(/ /g, '')
        .replace(/-/g, '')
        .padStart(getLength(), '0')

    return {
        inputZipCode: inputZipCode,
        zipCode: zipCode,
        errors: [],

        format: function () {
            if (!this.isValid()) {
                return this.inputZipCode
            }

            switch (configHandler.regionKey) {
                case 'sv':
                    return formatSV(this.zipCode)
                case 'no':
                default:
                    return formatNO(this.zipCode)
            }
        },

        isValid: function () {
            return this.validate().length === 0
        },
        validate: function () {
            this.errors = []

            if (!this.inputZipCode.length) {
                this.errors.push(configHandler.errorMessages().zip[INVALID_VALUE])
                return this.errors
            }

            if (this.zipCode.length !== getLength() || isNaN(this.zipCode)) {
                // No zipcode, invalid length or not a number
                // TODO: Separate to independent errors
                this.errors.push(configHandler.errorMessages().zip[INVALID_VALUE])
                return this.errors
            }

            return this.errors
        },


        input: function () {
            return inputZipCode
        },
    }
}

export default {
    parse,
    getLength,
}